import type {Uuid} from "@vesta/common-type-definitions/typeDefinitions";
import {uuidZodValidator} from "@vesta/global-common-typescript/validators/zodValidators";
import {z as zod, type ZodType} from "zod";

// export type DAG_SourceCredentialsSchema = Array<DAG_Field>;

// TODO: Convert to uuid?
export enum DAG_FieldType {
    string = "string",
}

export type DAG_Field = {
    id: Uuid;
    fieldName: string;
    fieldType: DAG_FieldType;
    displayName: string;
    description: string;
    isNullable: boolean;
};

export const dagFieldZodValidator: ZodType<DAG_Field> = zod.object({
    id: uuidZodValidator,
    fieldName: zod.string(),
    fieldType: zod.enum(DAG_FieldType),
    displayName: zod.string(),
    description: zod.string(),
    // Why is this even required?
    isNullable: zod.boolean(),
});
